<template>
  <div style="background-color: #f0f0f0 height: 100%;min-height: 765px;" >
    <div class="content">
      <p class="title">{{ this.newlist1[0].title }}</p>
      <p class="time">{{ this.newlist1[0].time }}</p>
      <hr style="border: 1px dashed #cccccc" width="1170px" size="2" />
      <div class="cnot" v-html="this.newlist1[0].content"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      id: 1,
      newlist1: [],
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.$http
      .get(`${this.$store.state.baseurl}/api/newslist?id=` + this.id)
      .then((res) => {
        const json = res.data;
        const obj = JSON.parse(json);

        this.newlist1 = obj.data;
      });
  },
};
</script>

<style scoped lang="scss">
.content {
  width: 1200px;
  margin: auto;
  padding-top: 15px;
  background-color: #ffffff;
  padding: 10px;

  .title {
    font-size: 24px;
  }
  .time {
    font-size: 13px;
  }
  .cnot {
    font-size: 13px;
    padding: 5px 10px 5px 10px;
    text-align: left;
    text-indent: 2em;
    letter-spacing: 0.5px;
  }
}
</style>
